import React from 'react';

import Hero from '../components/Hero';
import MarkdownRenderer from '../components/MarkdownRenderer';
import Section from '../components/Section';

const DefaultBaseTemplate = ({ pageContext: { page } }) => {
  if (!page) return null;

  return (
    <Section>
      <Hero {...page} />

      <div className="max-w-3xl mx-auto">
        <MarkdownRenderer {...page} />
      </div>
    </Section>
  );
};

export default DefaultBaseTemplate;
